import { ApplicationProgressStepper } from './ApplicationProgressStepper'

export function ApplicantTabNavigation() {
  return <ApplicationProgressStepper />
}

